// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".styles-module__Root___3vx1w textarea{min-height:100px}", "",{"version":3,"sources":["/tmp/build_9ddd188e/app/javascript/src/components/forms/Feedback/styles.module.scss"],"names":[],"mappings":"AAIE,sCACE,gBAAA","file":"styles.module.scss","sourcesContent":["@import \"../../../styles/mixins/index.scss\";\n@import \"../../../styles/variables/index.scss\";\n\n.Root {\n  textarea {\n    min-height: 100px;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"Root": "styles-module__Root___3vx1w"
};
module.exports = exports;
